import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const CmsBlockContainerWithDividers_Box_1 = styled.div`
  margin-top: 40px;
  max-width: 1200px;
  margin-inline: auto;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-top: 60px;
  }

  &[data-full-width-layout] {
    margin-top: 64px;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      margin-top: 70px;
    }
  }
`;

export const CmsBlockContainerWithDividers_Box_2 = styled.div`
  margin-bottom: 40px;
  max-width: 1200px;
  margin-inline: auto;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-bottom: 60px;
  }

  &[data-full-width-layout] {
    margin-bottom: 64px;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      margin-bottom: 70px;
    }
  }
`;
